const normalizeValue = (value) => String(value || '').trim().toLowerCase();

const parseCsvEnv = (value) => (
  String(value || '')
    .split(',')
    .map((entry) => normalizeValue(entry))
    .filter(Boolean)
);

const getSmsAdminUsernames = () => parseCsvEnv(process.env.REACT_APP_SMS_ADMIN_ALLOWED_USERNAMES || '');

const getSmsAdminGroupIds = () => parseCsvEnv(
  process.env.REACT_APP_SMS_ADMIN_ALLOWED_AAD_GROUP_IDS
    || process.env.REACT_APP_KARMA_IMPORT_ALLOWED_AAD_GROUP_IDS
    // || '0a73cf97-3e65-4b50-86cb-d14d8d871ac3'  //karma import group
    || 'cd053eaa-c9ca-405b-a935-783fc0041c9d'  //sms group
);

const getAccountUsername = (account) => normalizeValue(
  account?.username
  || account?.idTokenClaims?.preferred_username
  || account?.idTokenClaims?.upn
  || account?.idTokenClaims?.email
);

const getAccountGroups = (account) => {
  if (!Array.isArray(account?.idTokenClaims?.groups)) {
    return [];
  }

  return account.idTokenClaims.groups.map((groupId) => normalizeValue(groupId));
};

export const isSmsAdminAccount = (account) => {
  if (!account) {
    return false;
  }

  const allowedUsernames = getSmsAdminUsernames();
  const allowedGroupIds = getSmsAdminGroupIds();
  const username = getAccountUsername(account);
  const groups = getAccountGroups(account);

  const hasAllowedGroup = allowedGroupIds.length > 0
    && allowedGroupIds.some((groupId) => groups.includes(groupId));

  const hasAllowedUsername = allowedUsernames.length > 0
    && allowedUsernames.includes(username);

  return hasAllowedGroup || hasAllowedUsername;
};
